<!--Charibonでは仕分けページの表示を実験的にやめているので、このコンポーネントが使われていない状態となっている-->

<template>
  <div class="mb-16 justify-center">
    <validation-observer ref="observer" v-slot="observerProps">

      <v-row justify="center" class="ma-5 form-content">
        <div id="isbn-check">
          <div class="default-content-header">
            <h1>ご確認ください。<br>あなたの本が<span class="under-line">寄付にならない</span>かもしれません。</h1>
          </div>
          <div class="isbn-check-content max">
            <div class="image">
              <img :src="`${cdnBaseUrl}/charibon/images/offer/published.png`" alt="" />
            </div>
            <div class="text">
              <h3><span class="under-line">2010年より以前に出版された本</span>のほとんどが寄付になりません。</h3>
              <p class="main-txt">charibonにお送りいただく本のうち、約半数にお値段をつけることができず、古紙回収に回ってしまっています。その多くが2010年より以前に出版された古い本です。一部の専門書を除き、10年以上前に出版された古い本はお値段をつけることが難しいです。本の最後のページに出版された日付が記載されているので、ご確認をお願いいたします。</p>
            </div>
          </div>
          <div class="isbn-check-content herf">
            <div class="image">
              <img :src="`${cdnBaseUrl}/charibon/images/offer/isbn-image.png`" alt="" />
            </div>
            <div class="text">
              <p>ISBN(国際標準図書番号)がついていない本は査定することができません。</p>
            </div>
          </div>
          <div class="isbn-check-content herf">
            <div class="image">
              <img :src="`${cdnBaseUrl}/charibon/images/offer/comic_set.png`" alt="" />
            </div>
            <div class="text">
              <p>連載中や発売から一年以内のものを除き、不揃いの漫画セットは低価格の買取になってしまいます。特に古い漫画については、全巻そろっていてもお値段がつかない場合が多いです。</p>
            </div>
          </div>
          <div class="isbn-check-content">
            <div class="text">
              <p>以下のものも査定対象外となります。</p>
              <ul>
                <li><span>百科事典</span></li>
                <li><span>コンビニコミック</span></li>
                <li><span>個人出版の本</span></li>
                <li><span>マンガ雑誌</span></li>
                <li><span>一般雑誌</span></li>
                <li><span>同一タイトル11点以上</span></li>
                <li><span>シングルＣＤ</span></li>
                <li><span>投票券等特典付きＣＤ</span></li>
                <li><span>アダルト商品</span></li>
              </ul>
            </div>
          </div>
          <div class="isbn-check-content">
            <div class="image">
              <a :href="estimateUrl" target="_blank" >
                <img :src="`${cdnBaseUrl}/charibon/images/offer/bnr-vb.png`" alt="" />
              </a>
            </div>
            <div class="text">
              <p>チャリボンを運営するバリューブックスの「<a :href="estimateUrl" target="_blank" >おためし査定</a>」を使えば、事前に寄付になるかがわかります。
                こちらをご活用いただき、仕分けにご協力をお願いいたします。</p>
            </div>
          </div>
          <div class="check-ng-content">
            <p class="bold">寄付になる本、ならない本を仕分けしていただき、寄付にならない本をご自宅で古紙回収に回していただければ、コスト(輸送費・人件費)を抑えることができます。コストを抑えることができれば寄付金に還元することができます。どうか、ご協力をお願いいたします。</p>
          </div>
        </div>
      </v-row>

      <v-row justify="center" class="ma-5">
        <ul style="list-style-type: none;">
          <li>
            <validation-provider v-slot="{ errors }" :rules="{required: {allowFalse: false}}"
                           name="2010年以前に出版された本は送りません">
              <v-checkbox
                v-model="checkedAgreedWithNotOldBook"
                type="checkbox"
                dense
                height="auto"
                name="agreedWithNotOldBook"
                :ripple="false"
                :class="{'agreement-checkbox' : $vuetify.breakpoint.mdAndUp}"
                hide-details="auto"
              >
                <template #label>
                  <p class="text-body-2">
                    2010年以前に出版された本は送りません。<br/>
                    ※
                    <v-tooltip disabled>
                      <template v-slot:activator="{ on }">
                        <a
                          class="black--text text-decoration-underline"
                          :href="estimateUrl"
                          target="_blank"
                          @click.stop
                          v-on="on">
                          お試し査定
                        </a>
                      </template>
                    </v-tooltip>
                    で値段がついたものは除く
                  </p>
                </template>
              </v-checkbox>
            </validation-provider>
          </li>

          <li>
            <validation-provider v-slot="{ errors }" :rules="{required: {allowFalse: false}}"
                           name="ISBNの有無を確認しました">
              <v-checkbox
                v-model="checkedAgreedWithISBN"
                type="checkbox"
                dense
                height="auto"
                name="agreedWithISBN"
                :ripple="false"
                :class="{'agreement-checkbox' : $vuetify.breakpoint.mdAndUp}"
                hide-details="auto"
              >
                <template #label>
                  <div class="text-body-2">
                    ISBNの有無を確認しました。
                  </div>
                </template>
              </v-checkbox>
            </validation-provider>
          </li>
        </ul>
      </v-row>

      <v-row justify="center">
        <v-btn
          class="secondary white--text text-subtitle-1 text-md-h6 text-md-h6"
          :width="$vuetify.breakpoint.mdAndUp ? '500px' : '328px'"
          :height="$vuetify.breakpoint.mdAndUp ? '76px' : '48px'"
          :disabled="observerProps.invalid"
          @click="goToForm"
        >
          入力画面へ
        </v-btn>
      </v-row>
    </validation-observer>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import GtmOnVue from "../../../libs/gtmOnVue.js";

export default {
  name: "charibon-attention",
  components: {
  },
  data() {
    return {
      estimateUrl: "https://www.valuebooks.jp/estimate/guide?utm_source=charibon&utm_medium=referral&utm_campaign=valuebooks-otameshisatei",
      cdnBaseUrl: VueConfig.cdn_url.replace("/ws/site", ""),
      checkedAgreedWithNotOldBook: false,
      checkedAgreedWithISBN: false,
    }
  },
  provide: function () {
    //子コンポーネントでエラーをセットするため
    return {
      setErrors: this.observeSetErrors
    }
  },
  created() {
    this.setBuyFormItems({name: 'site_code', value: this.$siteCode});

    GtmOnVue.sendGAEventCharibonOfferAll(
      this.$route.query.id,
      (this.$route.query.kCode ? this.$route.query.kCode : this.$route.query.couponCode),
      this.$route.query.vboffice
    );
  },
  methods: {
    ...mapActions({
      setBuyFormItems: 'buy/updateFormItems',
    }),
    async goToForm() {
      this.$router.push({name: "CharibonEntryForm", query: this.$route.query});
    },
  },
  computed: {
    headingBgColor() {
      return this.$vuetify.breakpoint.mdAndUp ? 'transparent' : 'accent3';
    },
    headingTextColor() {
      return this.$vuetify.breakpoint.mdAndUp ? 'primaryTextColor' : 'white';
    },
    headingPadding() {
      return this.$vuetify.breakpoint.mdAndUp ? 'pa-0' : 'pa-0 pl-4';
    },
    countInvalidFields: function () {
      return function (fields) {
        let count = 0;
        for (let key of Object.keys(fields)) {
          !fields[key].valid && count++
        }
        return count;
      }
    },
    isBackFromConfirmation() {
      return this.$route.params.isBackButton;
    },

  },
  mounted() {
    if (this.$route.params.validate_on_load) {
      this.$refs.observer.validate();
    }
  },
}
</script>

<style scoped lang="scss">
::v-deep {
  #checkbox-multilines label {
    display: block;
  }

  .v-input--checkbox {
    label {
      color: rgba(0, 0, 0, 0.87);
    }
    .v-input__slot {
      align-items: flex-start;
    }
  }
  .agreement-checkbox {
    .v-icon {
      font-size: 28px;
    }
  }
}

// 以下は https://www.charibon.jp/donation/action.cgi よりコピー・一部修正(2023/10/07)
.form-content {
    position: relative;
}

img {
  width: 100%;
  height: auto;
}

.under-line {
    font-size: inherit;
    font-weight: inherit;
    background: -webkit-gradient(linear, left top, left bottom, color-stop(60%, transparent), color-stop(0%, #FDE000));
    background: -webkit-linear-gradient(transparent 60%, #FDE000 0%);
    background: linear-gradient(transparent 60%, #FDE000 0%);
}

.form-content #isbn-check {
    max-width: 840px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap
}

.form-content #isbn-check .default-content-header {
    width: 100%;
    margin-bottom: 20px;
}

.form-content #isbn-check .default-content-header h1 {
    font-size: 1.2em;
    text-align: center;
}

@media (max-width: 767px) {
    .form-content #isbn-check .default-content-header h1 {
        text-align: left
    }
}

.form-content #isbn-check .isbn-check-content {
    background: #ffffff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 10px;
    margin-bottom: 20px
}

.form-content #isbn-check .isbn-check-content.max {
    width: 100%
}

.form-content #isbn-check .isbn-check-content.herf {
    width: calc(50% - 10px)
}

.form-content #isbn-check .isbn-check-content .image {
    border-radius: 10px 10px 0 0;
    overflow: hidden
}

.form-content #isbn-check .isbn-check-content .text {
    padding: 30px
}

@media (max-width: 767px) {
    .form-content #isbn-check .isbn-check-content .text {
        padding: 14px
    }
}

.form-content #isbn-check .isbn-check-content .text h3 {
    margin-bottom: 30px;
    font-weight: 700;
    font-size: 1.1em
}

@media (max-width: 767px) {
    .form-content #isbn-check .isbn-check-content .text h3 {
        margin-bottom: 14px
    }
}

.form-content #isbn-check .isbn-check-content .text p {
    text-align: justify
}

.form-content #isbn-check .isbn-check-content ul {
    margin-top: 20px
}

@media (max-width: 767px) {
    .form-content #isbn-check .isbn-check-content ul {
        text-align: left
    }
}

.form-content #isbn-check .isbn-check-content ul li {
    display: inline-block;
    margin: 0 14px 10px;
    font-weight: 700
}

.form-content #isbn-check .isbn-check-content ul li span {
    display: inline;
    font-weight: 700;
    background: -webkit-gradient(linear, left top, left bottom, color-stop(60%, transparent), color-stop(0%, #FDE000));
    background: -webkit-linear-gradient(transparent 60%, #FDE000 0%);
    background: linear-gradient(transparent 60%, #FDE000 0%)
}

@media (max-width: 767px) {
    .form-content #isbn-check .isbn-check-content.herf {
        width: 100%
    }
}

.form-content #isbn-check .check-ng-content {
    margin-top: 40px
}

@media (max-width: 767px) {
    .form-content #isbn-check .check-ng-content {
        margin-top: 20px
    }
}

.form-content #isbn-check .check-ng-content .bold {
    width: 100%;
    margin: 0 auto 60px;
    font-weight: 700;
    text-align: justify;
    padding: 0 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box
}

@media (max-width: 767px) {
    .form-content #isbn-check .check-ng-content .bold {
        margin: 0 0 40px 0
    }
}

.form-content #isbn-check .check-ng-content dl {
    display: table;
    width: 100%;
    max-width: 450px;
    margin: 0 auto 20px
}

.form-content #isbn-check .check-ng-content dl dt {
    display: table-cell;
    width: 30px
}

.form-content #isbn-check .check-ng-content dl dd {
    display: table-cell
}

.form-content #isbn-check .check-ng-content dl dd label {
    font-weight: 700
}

.form-content #isbn-check .check-ng-content dl dd label span {
    display: block
}

.form-content #isbn-check .check-ng-content dl dd label span a {
    color: #333;
    text-decoration: underline
}

.form-content #isbn-check .check-ng-content .btn-apply {
    font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Segoe UI, Hiragino Kaku Gothic ProN, Hiragino Sans, ãƒ’ãƒ©ã‚®ãƒŽè§’ã‚´ ProN W3, Arial, ãƒ¡ã‚¤ãƒªã‚ª, Meiryo, sans-serif;
    font-weight: 700;
    line-height: 1;
    margin: 50px auto 0;
    cursor: pointer;
    font-size: 100%
}

.form-content #isbn-check .check-ng-content .btn-apply:disabled {
    background: #ccc
}

</style>